import { z } from 'zod';

import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { HorizontalAlignment } from '../../themes/theme';
import { WidgetType } from '../../utils/widgetsUtils';

export enum AnswerStyleType {
  Default = 'Default',
  Button = 'Button',
  CheckboxWithoutBorder = 'CheckboxWithoutBorder'
}

export enum ObjectFit {
  Cover = 'cover',
  Fill = 'fill',
  Contain = 'contain',
  None = 'none'
}

export enum ScrambleMode {
  SameForAll = 'sameForAll',
  RandomForEach = 'randomForEach'
}

const AnswerSchema = z.object({
  id: z.string(),
  text: z
    .object({
      /**
       * ProseMirror JSON
       */
      fragment: ProseMirrorJSONSchema
    })
    .optional(),
  image: z
    .object({
      src: z.string(),
      alt: z.string(),
      mobileSrc: z.string(),
      objectFit: z.nativeEnum(ObjectFit),
      mobileObjectFit: z.nativeEnum(ObjectFit),
      isDecorative: z.boolean().optional()
    })
    .optional(),
  audio: z
    .object({
      src: z.string(),
      title: z.string()
    })
    .optional(),
  video: z.object({}).optional()
});

export const SortQuestionWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.SortQuestion).extend({
  answerElements: z.array(z.string()),
  answers: z.array(AnswerSchema),
  firstPinnedAnswerId: z.string().nullable(),
  imagePosition: z.nativeEnum(HorizontalAlignment),
  lastPinnedAnswerId: z.string().optional().nullable(),
  saveAnswers: z.boolean(),
  scrambleMode: z.nativeEnum(ScrambleMode),
  scrambledAnswersOrder: z.array(z.string()),
  textAlign: z.nativeEnum(HorizontalAlignment)
});

export type SortQuestionWidgetStaticSchema = z.infer<typeof SortQuestionWidgetStaticSchema>;
